import styled from 'styled-components';

interface DivProps {
    error:boolean;
    height?: string;
}

export const Select = styled.select`
    width:100%;
    height:48px;
    font-size:16px;
    font-weight:400;
    padding: 0 20px;
    box-sizing: border-box;
    border-radius:4px;
    border: none;
    color:${props=>props.theme.colors.gray};
    background:${props=>props.theme.colors.white};
    background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%237B86A3%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E');
    background-repeat: no-repeat, repeat;
	background-position: right 20px top 50%, 0 0;
	background-size: .65em auto, 100%;
    -webkit-appearance: none;
`;

export const Option = styled.option`
    font-size:14px;
    font-weight:400;
    color:${props=>props.theme.colors.gray};
`;

export const Column = styled.div<DivProps>`
  width: 100%;
  border-radius: 4px;
  height: ${props => props.height};
  border:${props=>props.error ? `2px solid ${props.theme.colors.danger}` : `1.5px solid ${props.theme.colors.lightGray}` };
  
  
  @media screen and (max-width:960px){
    width: 100%;
  }
`;

export const TagError = styled.div`
  position:relative;
  padding:3px 8px 2px 8px;
  background:${props=>props.theme.colors.danger};
  font-weight:700;
  text-align:center;
  font-size:14px;
  color:${props=>props.theme.colors.white};
  width:max-content;
  border-radius:16px;
  top:-9px;
  margin:0 auto;
`;